import { FailedMessagesProfileItemFilterModel } from '../../models/profile/failed-messages-profile-item.model';

export class FailedMessagesProfileItemLoad {
  public static readonly type = '[FailedMessagesProfileItem] Load';

  constructor(public payload: number) {}
}

export class FailedMessagesProfileItemCreate {
  public static readonly type = '[FailedMessagesProfileItem] Create';

  constructor(public payload: FailedMessagesProfileItemFilterModel) {}
}

export class FailedMessagesProfileItemUpdate {
  public static readonly type = '[FailedMessagesProfileItem] Update';

  constructor(public payload: FailedMessagesProfileItemFilterModel) {}
}

export class FailedMessagesProfileItemInitialState {
  public static readonly type = '[FailedMessagesProfileItem] Set Initial State';
}
